/* 布局 */
//前台
import Layout from "@views/layout";

const sacrificehomeleaveRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "sacrificehomeleave/list",
        name: "SACRIFICEHOMELEAVE",
        meta: {
            title: "云祭祀房间留言",
            keepAlive:true
        },
        component: () => import("@views/business/sacrificehomeleave/index.vue"),
    },
        ],
};

export default sacrificehomeleaveRouter;
